var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35313 10.8531L8 11.2063L7.64687 10.8531L3.64687 6.85313L3.29375 6.5L4 5.79375L4.35313 6.14687L7.5 9.29375V0.5V0H8.5V0.5V9.29375L11.6469 6.14687L12 5.79375L12.7063 6.5L12.3531 6.85313L8.35313 10.8531ZM2 10.5V15H14V10.5V10H15V10.5V15.5V16H14.5H1.5H1V15.5V10.5V10H2V10.5Z",
    fill: "#1D1F2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.39a085d73d3c66c8e96864c321928670.svg";
export { ForwardRef as ReactComponent };